import {
  Axis,
  MediaBrowserPanelConfig,
} from '../../../../PanelMediaBrowser/common';
import {MediaConfigWithDefaults} from '../../../../PanelMediaBrowser/Component';

type AxisKey = keyof NonNullable<MediaBrowserPanelConfig['gridSettings']>;

function getOtherAxisKey(axisKey: AxisKey): AxisKey {
  return axisKey === 'xAxis' ? 'yAxis' : 'xAxis';
}

export function updateAxisConfig(
  option: Axis,
  config: MediaConfigWithDefaults,
  updateConfig: (config: Partial<MediaBrowserPanelConfig>) => void,
  axisKey: AxisKey
) {
  const otherAxisKey = getOtherAxisKey(axisKey);
  // When the same axis is picked for both cause a swap
  if (option === config.gridSettings[otherAxisKey]) {
    updateConfig({
      gridSettings: {
        ...config.gridSettings,
        [otherAxisKey]: config.gridSettings[axisKey],
        [axisKey]: option,
      },
    });
  } else {
    updateConfig({
      gridSettings: {
        ...config.gridSettings,
        [axisKey]: option,
      },
    });
  }
}
